import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import '../../../styles/index.css';

const FeaturedMotors = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const navigate = useNavigate();


  const categories = [
  { id: 'all', label: 'Semua Motor', icon: 'Bike' },
  { id: 'matic', label: 'Matic', icon: 'Zap' },
  { id: 'sport', label: 'Sport', icon: 'Gauge' },
  { id: 'bebek', label: 'Bebek', icon: 'Fuel' }];


  const motors = [
    {
      id: 1,
      name: "Honda BeAT",
      slug: "beat",
      category: "matic",
      type: "Matic Paling Irit",
      price: "Rp 19.174.000",
      image: "/assets/motor/HondaBeAT.webp",
      imageAlt: "Honda BeAT",
      badge: "Terlaris",
      badgeColor: "bg-success",
      features: ["eSP", "Combi Brake", "ISS"],
      specs: {
        engine: "109.5 cc",
        power: "9.0 PS",
        fuel: "60 km/l"
      }
    },
    {
      id: 2,
      name: "Honda Vario 160",
      slug: "vario-160",
      category: "matic",
      type: "Matic Sporty",
      price: "Rp 28,342,000",
      image: "/assets/motor/HondaVario160.webp",
      imageAlt: "Honda Vario 160",
      badge: "Favorit Anak Muda",
      badgeColor: "bg-warning",
      features: ["160cc", "ABS", "Smart Key"],
      specs: {
        engine: "156.9 cc",
        power: "15.8 PS",
        fuel: "46 km/l"
      }
    },
    {
      id: 3,
      name: "Honda PCX 160",
      slug: "pcx-160",
      category: "matic",
      type: "Matic Premium",
      price: "Rp 34,592,000",
      image: "/assets/motor/PcxExceptionalRedCBS.webp",
      imageAlt: "Honda PCX 160",
      badge: "Premium Choice",
      badgeColor: "bg-primary",
      features: ["CBS", "HSTC", "Smart Key"],
      specs: {
        engine: "156.9 cc",
        power: "15.8 PS",
        fuel: "45 km/l"
      }
    },
    {
      id: 4,
      name: "Honda CB150X",
      slug: "cb150x",
      category: "sport",
      type: "Sport Adventure",
      price: "Rp 35.214.000",
      image: "/assets/motor/HondaCB.jpg",
      imageAlt: "Honda CB150X",
      badge: "Adventure Style",
      badgeColor: "bg-primary",
      features: ["DOHC", "Assist & Slipper Clutch", "ABS"],
      specs: {
        engine: "149.2 cc (DOHC)",
        power: "15.6 PS",
        fuel: "±38 km/l"
      }
    },
    {
      id: 5,
      name: "Honda Stylo 160",
      slug: "stylo-160",
      category: "matic",
      type: "Matic Stylish",
      price: "Rp 29.463.000",
      image: "/assets/motor/HondaStylo.webp",
      imageAlt: "Honda Stylo 160",
      badge: "New Model",
      badgeColor: "bg-success",
      features: ["eSP+", "Smart Key", "CBS"],
      specs: {
        engine: "156.9 cc (eSP+)",
        power: "15.8 PS",
        fuel: "±45 km/l"
      }
    },
    {
      id: 6,
      name: "Honda Revo",
      slug: "revo",
      category: "bebek",
      type: "Bebek Irit",
      price: "Rp 18.179.000",
      image: "/assets/motor/HondaRevo.webp",
      imageAlt: "Honda Revo",
      badge: "Paling Irit",
      badgeColor: "bg-warning",
      features: ["PGM-FI", "Irit BBM", "Tangguh"],
      specs: {
        engine: "109.2 cc",
        power: "8.9 PS",
        fuel: "±59 km/l"
      }
    }

  ];


  const filteredMotors = activeCategory === 'all' ?
  motors :
  motors?.filter((motor) => motor?.category === activeCategory);

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12" data-aos="fade-up">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full mb-4">
            <Icon name="Star" size={18} color="var(--color-primary)" />
            <span className="text-sm font-heading font-semibold text-primary">
              Motor Pilihan
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            Motor Honda Terpopuler
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Temukan motor Honda yang sesuai dengan kebutuhan dan gaya hidup Anda
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-8 md:mb-12" data-aos="fade-up" data-aos-delay="150">
          {categories?.map((category) =>
          <button
            key={category?.id}
            onClick={() => setActiveCategory(category?.id)}
            className={`flex items-center space-x-2 px-4 md:px-6 py-2 md:py-3 rounded-lg font-heading font-semibold text-sm transition-all duration-300 ${
            activeCategory === category?.id ?
            'bg-primary text-primary-foreground shadow-honda-subtle' :
            'bg-card text-foreground hover:bg-primary/10 hover:text-primary'}`
            }>

              <Icon name={category?.icon} size={18} />
              <span>{category?.label}</span>
            </button>
          )}
        </div>

        <div key={activeCategory} data-aos="fade-up"data-aos-delay="200"className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredMotors?.map((motor) =>
          <div
            key={motor?.id}
            className="group bg-card rounded-xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1">

              <div className="relative aspect-[4/3] overflow-hidden">
                <Image
                src={motor?.image}
                alt={motor?.imageAlt}
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className={`${motor?.badgeColor} text-white px-3 py-1 rounded-full text-xs font-heading font-semibold shadow-lg`}>
                    {motor?.badge}
                  </span>
                </div>
                <div className="absolute top-4 right-4">
                  <button
                  className="w-10 h-10 bg-card/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors"
                  aria-label="Add to favorites">

                    <Icon name="Heart" size={20} />
                  </button>
                </div>
              </div>

              <div className="p-6 space-y-4">
                <div>
                  <p className="text-xs text-primary font-heading font-semibold mb-1">
                    {motor?.type}
                  </p>
                  <h3 className="text-xl font-heading font-bold text-foreground mb-2">
                    {motor?.name}
                  </h3>
                  <p className="text-2xl font-heading font-bold text-primary">
                    {motor?.price}
                  </p>
                </div>

                <div className="flex flex-wrap gap-2">
                  {motor?.features?.map((feature, index) =>
                <span
                  key={index}
                  className="px-3 py-1 bg-muted rounded-full text-xs font-medium text-foreground">

                      {feature}
                    </span>
                )}
                </div>

                <div className="grid grid-cols-3 gap-3 pt-4 border-t border-border">
                  <div className="text-center">
                    <Icon name="Gauge" size={18} color="var(--color-muted-foreground)" className="mx-auto mb-1" />
                    <p className="text-xs text-muted-foreground">{motor?.specs?.engine}</p>
                  </div>
                  <div className="text-center">
                    <Icon name="Zap" size={18} color="var(--color-muted-foreground)" className="mx-auto mb-1" />
                    <p className="text-xs text-muted-foreground">{motor?.specs?.power}</p>
                  </div>
                  <div className="text-center">
                    <Icon name="Fuel" size={18} color="var(--color-muted-foreground)" className="mx-auto mb-1" />
                    <p className="text-xs text-muted-foreground">{motor?.specs?.fuel}</p>
                  </div>
                </div>

                <div className="flex gap-3 pt-2">
                  <Button
                    variant="outline"
                    size="sm"
                    fullWidth
                    iconName="Info"
                    iconPosition="left"
                    onClick={() => navigate(`/produk/motor/${motor.slug}`)}
                    >
                    Detail
                   </Button>
                  <Button
                  variant="default"
                  size="default"
                  fullWidth
                  iconName="MessageCircle"
                  iconPosition="left"
                  onClick={() => window.open(`https://wa.me/6288293642972?text=Halo, saya tertarik dengan ${motor?.name}`, '_blank')}>
                    Konsultasi
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="text-center mt-12" data-aos="fade-up" data-aos-delay="200">
          <Button
            variant="default"
            size="lg"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={() => window.location.href = '/produk/motor'}
            className="shadow-honda-subtle">

            Lihat Semua Motor Honda
          </Button>
        </div>
      </div>
    </section>);

};

export default FeaturedMotors;